import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    ReportingDepartment, AddressMainCategory,
} from 'app/enums/label.enums'
import {
    Damage,
} from '../Damages.types'

const getDamageCreateFields = (getAllowedValues): DTOCardFormField<keyof Damage>[] => {
    return [{
        title: 'Damage Details',
        fields: [
            {
                id: 'column1',
                fields: [
                    {
                        name: 'container',
                        componentName: 'ContainerSelector',
                        required: true,
                        labelKey: 'CONTAINER_SERIAL_NUMBER',
                    },
                    {
                        name: 'reportingServiceCenter',
                        componentName: 'LocationObjectSelector',
                        filterAddressMainCategory: AddressMainCategory.SERVICECENTER,
                        labelKey: 'REPORTING_SERVICE_CENTER',
                    },
                    {
                        name: 'damageType',
                        componentName: 'DamageTypeSelector',
                        required: true,
                        labelKey: 'DAMAGE_TYPE',
                    },
                ],
            },
            {
                id: 'column2',
                fields: [
                    {
                        name: 'reportedOn',
                        componentName: 'DateTimeSelect',
                        required: true,
                        labelKey: 'REPORTED_ON_UTC',
                    },
                    {
                        name: 'damageComment',
                        componentName: 'LongText',
                        labelKey: 'DAMAGE_COMMENT',
                    },
                ],
            },
            {
                id: 'column3',
                fields: [
                    {
                        name: 'reportedBy',
                        componentName: 'ContactObjectSelector',
                        required: true,
                        labelKey: 'REPORTED_BY',
                    },
                    {
                        name: 'reportingDepartment',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(ReportingDepartment),
                        required: true,
                        useDropdown: true,
                        labelKey: 'REPORTING_DEPARTMENT',
                    },
                ],
            },
            {
                id: 'column4',
                fields: [{
                    name: 'damageAttachments',
                    componentName: 'AttachmentsObjectSelector',
                    labelKey: 'DAMAGE_ATTACHMENT',
                }],
            },
        ],
    }]
}

export default getDamageCreateFields
